export const numericSpace = {
  /** 0 */
  none: 0,
  /** 2 */
  xxsmall: 2,
  /** 4 */
  xsmall: 4,
  /** 8 */
  small: 8,
  /** 16 */
  medium: 16,
  /** 24 */
  large: 24,
  /** 32 */
  xlarge: 32,
  /** 64 */
  xxlarge: 64,
};

export const space = {
  /** 0 pixels */
  none: `${numericSpace.none}`,
  /** 2 pixels */
  xxsmall: `${numericSpace.xxsmall}px`,
  /** 4 pixels */
  xsmall: `${numericSpace.xsmall}px`,
  /** 8 pixels */
  small: `${numericSpace.small}px`,
  /** 16 pixels */
  medium: `${numericSpace.medium}px`,
  /** 24 pixels */
  large: `${numericSpace.large}px`,
  /** 32 pixels */
  xlarge: `${numericSpace.xlarge}px`,
  /** 64 pixels */
  xxlarge: `${numericSpace.xxlarge}px`,
};

export type Space = keyof typeof space;
